import { getRequest } from "../../utils/request";
const url = 'api'


export const getProfileAPI = data => getRequest(`/${url}/auth/getProfile`, data)
